import { useState } from 'react';
import { useGameStore } from '../../store/gameSlice';
import { saveService } from '../../services/SaveService';
import { hubService } from '../../services/HubService';
import { multiplayerService } from '../../services/MultiplayerService';
import { getCoopResume } from '../../net/reconnect';
import { useMenuNavigation } from '../../hooks/menu/useMenuNavigation';
import { openInterface } from '../../services/InterfaceService';
import { ConfirmPopup } from './ConfirmPopup';
import pkg from '../../../package.json';
import './MainMenu.scss';

const MainMenu = () => {
  const setGameplay = useGameStore((s) => s.setGameplay);
  const [resumeNetError, setResumeNetError] = useState(false);

  const { containerRef } = useMenuNavigation({
    disabled: resumeNetError,
    onConfirm: (id) => {
      if (id === 'play') {
        const saved = saveService.load();
        if (getCoopResume()) {
          // Client co-op reload: rejoin the live run (same trigger as the host's
          // resume below, so both sides resume on "Jouer", not at boot).
          void multiplayerService.resumeCoopRun();
        } else if (saved?.coop) {
          // Host co-op resume: re-host the saved lobby. If signaling is
          // unreachable, surface the network-error dialog instead of failing
          // silently (the save is kept so the user can relaunch + retry).
          void multiplayerService
            .resumeHost(saved.coop.code, saved.coop.roomId)
            .then((ok) => {
              if (!ok) {
                setResumeNetError(true);
              }
            });
        } else if (saved) {
          setGameplay('dungeon');
        } else {
          void hubService.enterHub('default');
        }
      } else if (id === 'options') {
        openInterface('options');
      }
    },
  });

  return (
    <div className="MainMenu">
      <div className="main-menu-bg main-menu-bg--1" />
      <div className="main-menu-bg main-menu-bg--2" />
      <div className="main-menu-bg main-menu-bg--3 main-menu-bg--floating-a" />
      <div className="main-menu-bg main-menu-bg--4 main-menu-bg--floating-b" />

      <div className="menu-title">Usagi</div>
      <div className="menu-version">version {pkg.version}</div>

      <div className="menu-buttons" ref={containerRef}>
        <div
          className="menu-btn menu-btn"
          data-nav-row={0}
          data-nav-col={0}
          data-nav-id="play"
        >
          Jouer
        </div>
        <div
          className="menu-btn"
          data-nav-row={1}
          data-nav-col={0}
          data-nav-id="options"
        >
          Options
        </div>
      </div>

      {resumeNetError && (
        <ConfirmPopup
          title="Problème réseau"
          message="Serveur de session injoignable. Relance-le puis réessaie, ou abandonne la run multijoueur pour rejoindre ton hub solo (perte partielle habituelle)."
          confirmLabel="Abandonner la run"
          cancelLabel="Plus tard"
          onConfirm={() => {
            setResumeNetError(false);
            multiplayerService.abandonCoopResumeToSolo();
          }}
          onCancel={() => setResumeNetError(false)}
        />
      )}
    </div>
  );
};

export default MainMenu;
